import type { AraRemoveFrame, AraRemoveIntent } from '@/features/ara-generation/types/ara-events'

export function removeProposalKindKey(
  targetType: string
): 'column' | 'group' | 'section' | 'element' {
  if (targetType === 'column') return 'column'
  if (targetType === 'group') return 'group'
  if (targetType === 'section' || targetType === 'section-body') return 'section'
  return 'element'
}

export function removeProposalEnclosing(frame: AraRemoveFrame): string {
  return frame.parent_label || frame.section_label || ''
}

export function formatRemoveProposalCaption(parts: {
  operation: string
  kind: string
  label: string
  enclosing: string
}): string {
  const head = `${parts.operation} · ${parts.kind} '${parts.label}'`
  if (!parts.enclosing) return head
  return `${head} · ${parts.enclosing}`
}

function quotedAttr(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
}

export function removeIntentFromFrame(frame: AraRemoveFrame): AraRemoveIntent {
  const sectionKey = frame.section_key || undefined
  if (sectionKey && removeProposalKindKey(frame.target_type) === 'section') {
    return { sectionKey, wholeSection: true }
  }
  if (frame.target_type === 'column' || (frame.group && frame.column)) {
    return {
      sectionKey,
      group: frame.group,
      column: frame.column,
      columnLabel: frame.label
    }
  }
  if (frame.key) return { sectionKey, key: frame.key }
  if (frame.group) {
    return { sectionKey, selector: `[data-edit-group="${quotedAttr(frame.group)}"]` }
  }
  if (frame.target) return { sectionKey, id: frame.target }
  return { sectionKey }
}
